var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2081 5.05291C16.2081 4.75237 16.0887 4.46413 15.8762 4.25162C15.6637 4.0391 15.3755 3.91971 15.0749 3.91971H7.70914L6.34931 2.1066C6.24375 1.96586 6.10688 1.85163 5.94953 1.77296C5.79218 1.69428 5.61867 1.65332 5.44275 1.65332H2.60976C2.30922 1.65332 2.02098 1.77271 1.80847 1.98523C1.59595 2.19774 1.47656 2.48597 1.47656 2.78652V12.9853C1.47656 13.2858 1.59595 13.5741 1.80847 13.7866C2.02098 13.9991 2.30922 14.1185 2.60976 14.1185H15.0749C15.3755 14.1185 15.6637 13.9991 15.8762 13.7866C16.0887 13.5741 16.2081 13.2858 16.2081 12.9853V5.05291Z",
    stroke: "#00A3FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon2);
export default __webpack_public_path__ + "static/media/folder-icon2.a26969a64953174e22a038aa7bbb0e70.svg";
export { ForwardRef as ReactComponent };